import organizationService from './OrganizationService';
import dashboardService from './DashboardService';
import deviceService from './DeviceService';
import userService from './UserService';
import activityLogService from './ActivityLogService';

export const API = {
    ...organizationService,
    ...dashboardService,
    ...deviceService,
    ...userService,
    ...activityLogService,
};
